import React from 'react';
import Select from 'react-select';

import UpDownArrowIcon from '../../icons/UpDownArrowIcon';
import permissionsOptions, { userIsAdmin, userIsDeactivated } from '../../../utils/permissionsOptions';

function UsersListItem({ user, handleSelectChange }) {
  return (
    <div className={`user-list__card ${userIsDeactivated(user) ? ' user-list__card--deactivated' : ''}`}>
      <div className="user-list__col-1">
        <div className="user-list__name">
          {user.firstName + ' ' + user.lastName}
        </div>
        <div className="user-list__email">
          {user.email || 'Email'}
        </div>
        <div className="user-list__date">
          Account Created:
          {' '}
          {new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
          }).format(new Date(user.createdAt))}
        </div>
      </div>
      <div className="user-list__col-2">
        {user.department || 'N/A'}
      </div>
      <div className="user-list__col-3">
        <Select
          onChange={selected => handleSelectChange(user.id, selected)}
          value={user.roleId}
          disabled={userIsAdmin(user)} // Administrator can't be changed
          searchable={false}
          clearable={false}
          menuPlacement="auto"
          menuShouldScrollIntoView
          arrowRenderer={({ isOpen }) => (
            <UpDownArrowIcon direction={isOpen ? 'asc' : 'desc'} />
          )}
          options={permissionsOptions}
        />
      </div>
    </div>
  );
}

export default UsersListItem;



// WEBPACK FOOTER //
// ./src/components/features/account/UsersListItem.js